import React from 'react';

import './EditIcon.scss';

export default class EditIcon extends React.PureComponent {
    constructor(props) {
        super();
    }

    render() {
        return (
            <svg
                className="svg-edit-icon"
                width="48"
                height="48"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <circle id="b" cx="16" cy="16" r="16" />
                    <filter
                        x="-40.6%"
                        y="-34.4%"
                        width="181.2%"
                        height="181.2%"
                        filterUnits="objectBoundingBox"
                        id="a"
                    >
                        <feOffset
                            dy="2"
                            in="SourceAlpha"
                            result="shadowOffsetOuter1"
                        />
                        <feGaussianBlur
                            stdDeviation="4"
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                        />
                        <feColorMatrix
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            in="shadowBlurOuter1"
                        />
                    </filter>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g
                        className={'svg-edit-icon__circle-group'}
                        transform="translate(8 6)"
                    >
                        <use
                            className={'svg-edit-icon__circle-shadow'}
                            filter="url(#a)"
                            xlinkHref="#b"
                        />
                        <use
                            className={'svg-edit-icon__circle'}
                            xlinkHref="#b"
                        />
                    </g>
                    <path
                        className={'svg-edit-icon__pencil'}
                        d="M22.572 29.95h6.229c.465 0 .842.388.842.865a.853.853 0 0 1-.842.863h-8.696a.849.849 0 0 1-1.03-.835c-.033-3.423-.022-4.535.106-4.853l5.101-12.677c.29-.717 1.083-1.088 1.797-.835l2.931 1.073c.744.262 1.11 1.114.804 1.866l-5.1 12.678c-.118.29-.586.7-2.142 1.856zm-1.794-3.424l-.001.014a4.864 4.864 0 0 0-.01.178c-.009.194-.015.476-.018.843-.004.424-.005.96-.002 1.606.674-.497 1.22-.905 1.64-1.224a24.63 24.63 0 0 0 .832-.661l4.915-12.218-2.383-.873-5.008 12.445a.379.379 0 0 0 .035-.11z"
                        fill="#FFF"
                        fillRule="nonzero"
                    />
                </g>
            </svg>
        );
    }
}
